import styled from 'styled-components'

export const DropdownButton = styled.div`
  position: relative;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  color: #6ec1e4;
  align-items: center;

  img {
    margin-left: 0.5rem;
  }
`

export const DropdownIconStyle = styled.img`
  transition: transform 0.3s ease;
   max-width: 100%;

  &.active {
    transform: rotate(180deg);
  }

    @media (max-width: 768px) {
    width: 1.5em; /* Reduz o tamanho em dispositivos menores */
  }

  @media (max-width: 480px) {
    width: 1.2em; /* Reduz ainda mais para telas de celulares */
  }
`

export const DropdownExibition = styled.div``
